var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1278_21727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 2.66602C8.6362 2.66602 2.66687 8.63535 2.66687 15.9993C2.66687 22.654 7.54287 28.17 13.9175 29.1713V19.8527H10.5309V15.9993H13.9175V13.062C13.9175 9.72068 15.9069 7.87535 18.9535 7.87535C20.4122 7.87535 21.9375 8.13535 21.9375 8.13535V11.4153H20.2575C18.6002 11.4153 18.0842 12.4433 18.0842 13.498V15.9993H21.7815L21.1909 19.8527H18.0842V29.1713C24.4575 28.1713 29.3335 22.6527 29.3335 15.9993C29.3335 8.63535 23.3642 2.66602 16.0002 2.66602Z",
    fill: "#3B5998"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1278_21727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.398a7c3b8a87cc32ba22a2f0b4c36613.svg";
export { ForwardRef as ReactComponent };